module.exports = __webpack_public_path__ + "img/tree-05-h-leaves.ddc627c5.png";